import { UserAddIcon } from '@heroicons/react/outline';
import { t } from '@nodal/i18n';

export const NoParentsScreen = () => {
  return (
    <div className="flex flex-col flex-1 justify-center items-center">
      <UserAddIcon className="aspect-square mb-8 w-12 stroke-grey-forest-400 stroke-1" />
      <p className="mb-2 font-avenir-next text-2xl font-semibold leading-8 text-grey-forest-900">
        {t('No parents')}
      </p>

      <p className="mb-6 font-avenir-next text-base font-normal leading-6 text-center text-grey-forest-600">
        {t('At the moment, no parent profiles have been found.')}
      </p>
    </div>
  );
};
